<script setup>
import { useForm, Head, Link } from '@inertiajs/vue3';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import moment from 'moment'
import 'moment/dist/locale/nl';
import InputNumber from 'primevue/inputnumber';

const props = defineProps({ options: Array, conditionCategories: Array, userSearch: Object })
const carrosseries = [
    { "name": "Sedan", "value": "sedan" },
    { "name": "Hatchback", "value": "hatchback" },
    { "name": "Stationwagen", "value": "stationwagen" },
    { "name": "SUV", "value": "suv" },
    { "name": "Coupé", "value": "coupe" },
    { "name": "Cabriolet", "value": "cabriolet" },
    { "name": "MPV (Multi-Purpose Vehicle)", "value": "mpv" },
    { "name": "Pick-up", "value": "pick-up" },
    { "name": "Bestelwagen", "value": "bestelwagen" },
    { "name": "Sportwagen", "value": "sportwagen" },
    { "name": "Roadster", "value": "roadster" },
    { "name": "Limousine", "value": "limousine" },
    { "name": "Crossover", "value": "crossover" },
    { "name": "Overig", "value": "overig" }
]
const constructionYears = [];
for (let i = 0; i < 50; i++) {
    constructionYears.push(moment().year() - i);
}
const fuelTypes = [
    { "name": "Benzine", "value": "benzine" },
    { "name": "Diesel", "value": "diesel" },
    { "name": "Elektrisch", "value": "elektriciteit" },
    { "name": "LPG", "value": "lpg" },
    { "name": "Benzine-Elektrisch", "value": "benzine-elektriciteit" },
    { "name": "Diesel-Elektrisch", "value": "diesel-elektriciteit" },
]
const transmissionTypes = [
    { "name": "Handgeschakeld", "value": "handgeschakeld" },
    { "name": "Automaat", "value": "automaat" },
    { "name": "Semi-automaat", "value": "semi-automaat" },
]
const colors = [
    { "name": "Rood", "value": "rood" },
    { "name": "Blauw", "value": "blauw" },
    { "name": "Groen", "value": "groen" },
    { "name": "Zwart", "value": "zwart" },
    { "name": "Wit", "value": "wit" },
    { "name": "Grijs", "value": "grijs" },
    { "name": "Geel", "value": "geel" },
    { "name": "Oranje", "value": "oranje" },
    { "name": "Paars", "value": "paars" },
    { "name": "Roze", "value": "roze" },
    { "name": "Bruin", "value": "bruin" },
    { "name": "Beige", "value": "beige" },
    { "name": "Turquoise", "value": "turquoise" }
]
const interiorTypes = [
    { "name": "Stof", "value": "stof" },
    { "name": "Leer", "value": "leer" },
    { "name": "Half leder", "value": "halfleer" },
    { "name": "Alcantara", "value": "alcantara" },
    { "name": "Overig", "value": "overig" },
]
const form = useForm({
  name: props.userSearch.name,
  make: props.userSearch.make,
  model: props.userSearch.model,
  transmission: props.userSearch.transmission,
  fuel_type: props.userSearch.fuel_type,
  min_mileage: props.userSearch.min_mileage,
  max_mileage: props.userSearch.max_mileage,
  min_price: props.userSearch.min_price,
  max_price: props.userSearch.max_price,
  body_type: props.userSearch.body_type,
  min_construction_year: props.userSearch.min_year,
  max_construction_year: props.userSearch.max_year,
  options: props.userSearch.options.map(option => option.id),
  explanation: props.userSearch.explanation,
  min_power: props.userSearch.min_power,
  max_power: props.userSearch.max_power,
  color: props.userSearch.color,
  interior: props.userSearch.interior,
})
function submit() {
  form.post('/portal/zoekopdracht/' + props.userSearch.id + '/edit', {
    onSuccess: () => {
      //
    }
  });

}
</script>

<template>
  <Head title="Zoekopdracht aanpassen | Mijnautosnelweg" />
  <form class="px-4 sm:px-6 py-6 space-y-8" @submit.prevent="submit">
    <div class="space-y-4">
      <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Nieuwe zoekopdracht</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Vul hier alle informatie in om je zoekopdracht zo uitgebreid
            mogelijk te maken!</p>
        </div>
        <div class="grid grid-cols-1 gap-6 sm:grid-cols-6 md:col-span-2">
          <div class="col-span-full">
            <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Naam</label>
            <div class="mt-2">
              <input type="text" name="name" id="name" autocomplete="address-level2" v-model="form.name"
                class="input-style" />
            </div>
            <div v-if="form.errors.name" class="text-red-500 text-sm mt-1">
              {{ form.errors.name }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="make" class="block text-sm font-medium leading-6 text-gray-900">Merk</label>
            <div class="mt-2">
              <input type="text" name="make" id="make" v-model="form.make" class="input-style" />
            </div>
            <div v-if="form.errors.make" class="text-red-500 text-sm mt-1">
              {{ form.errors.make }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Model (handelsnaam)</label>
            <div class="mt-2">
              <input type="text" name="model" id="model" v-model="form.model" class="input-style" />
            </div>
            <div v-if="form.errors.model" class="text-red-500 text-sm mt-1">
              {{ form.errors.model }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="body_type" class="block text-sm font-medium leading-6 text-gray-900">Carrosserie</label>
            <div class="mt-2">
              <Dropdown showClear v-model="form.body_type" :options="carrosseries" optionLabel="name"
                optionValue="value" placeholder="Selecteer een carrosserie" class="dropdown-style" />
            </div>
            <div v-if="form.errors.body_type" class="text-red-500 text-sm mt-1">
              {{ form.errors.body_type }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Brandstof</label>
            <div class="mt-2">
              <Dropdown showClear v-model="form.fuel_type" :options="fuelTypes" optionLabel="name" optionValue="value"
                placeholder="Selecteer een brandstof type" class="dropdown-style" />

            </div>
            <div v-if="form.errors.name" class="text-red-500 text-sm mt-1">
              {{ form.errors.fuel_type }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Transmissie</label>
            <div class="mt-2">
              <Dropdown showClear v-model="form.transmission" :options="transmissionTypes" optionLabel="name"
                optionValue="value" placeholder="Selecteer een transmissie type" class="dropdown-style" />
            </div>
            <div v-if="form.errors.transmission" class="text-red-500 text-sm mt-1">
              {{ form.errors.transmission }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">KM stand</label>
            <div class="mt-2 space-y-2">
              <InputNumber v-model="form.min_mileage" class="input-style" suffix=" km" locale="nl-NL" placeholder="Vanaf"/>
              <InputNumber v-model="form.max_mileage" class="input-style" suffix=" km" locale="nl-NL" placeholder="Tot" />
            </div>
            <div v-if="form.errors.min_mileage" class="text-red-500 text-sm mt-1">
              {{ form.errors.min_mileage }}
            </div>
            <div v-if="form.errors.max_mileage" class="text-red-500 text-sm mt-1">
              {{ form.errors.max_mileage }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Bouwjaar</label>
            <div class="mt-2 space-y-2">
              <Dropdown showClear v-model="form.min_construction_year" :options="constructionYears" placeholder="Vanaf"
                class="dropdown-style" />
              <Dropdown showClear v-model="form.max_construction_year" :options="constructionYears" placeholder="Tot"
                class="dropdown-style" />
            </div>
            <div v-if="form.errors.min_construction_year" class="text-red-500 text-sm mt-1">
              {{ form.errors.min_construction_year }}
            </div>
            <div v-if="form.errors.max_construction_year" class="text-red-500 text-sm mt-1">
              {{ form.errors.max_construction_year }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Prijs</label>
            <div class="mt-2 space-y-2">
              <InputNumber v-model="form.min_price" inputId="currency-netherlands" mode="currency"
              currency="EUR" locale="nl-NL" class="input-style" placeholder="Vanaf"/>
              <InputNumber v-model="form.max_price" inputId="currency-netherlands" mode="currency"
              currency="EUR" locale="nl-NL" class="input-style" placeholder="Tot"/>
            </div>
            <div v-if="form.errors.min_price" class="text-red-500 text-sm mt-1">
              {{ form.errors.min_price }}
            </div>
            <div v-if="form.errors.max_price1" class="text-red-500 text-sm mt-1">
              {{ form.errors.max_price1 }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Vermogen (pk)</label>
            <div class="mt-2 space-y-2">
              <InputNumber v-model="form.min_power" class="input-style" suffix=" pk" locale="nl-NL" placeholder="Vanaf"/>
              <InputNumber v-model="form.max_power" class="input-style" suffix=" pk" locale="nl-NL" placeholder="Tot" />
            </div>
            <div v-if="form.errors.min_power" class="text-red-500 text-sm mt-1">
              {{ form.errors.min_power }}
            </div>
            <div v-if="form.errors.max_power" class="text-red-500 text-sm mt-1">
              {{ form.errors.max_power }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Kleur</label>
            <div class="mt-2 space-y-2">
              <Dropdown showClear v-model="form.color" :options="colors" optionLabel="name" optionValue="value"
                placeholder="Kleur" class="dropdown-style" />
            </div>
            <div v-if="form.errors.color" class="text-red-500 text-sm mt-1">
              {{ form.errors.color }}
            </div>
          </div>
          <div class="sm:col-span-2">
            <label for="merk" class="block text-sm font-medium leading-6 text-gray-900">Intereur</label>
            <div class="mt-2 space-y-2">
              <Dropdown showClear v-model="form.interior" :options="interiorTypes" optionLabel="name"
                optionValue="value" placeholder="Interieur" class="dropdown-style" />
            </div>
            <div v-if="form.errors.interior" class="text-red-500 text-sm mt-1">
              {{ form.errors.interior }}
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Gewenste opties</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Als er bepaalde opties aanwezig moeten zijn kun je deze hier
            selecteren.</p>
        </div>
        <div class="mt-5 mb-4 w-full flex flex-wrap gap-y-7 gap-x-3 col-span-2">
            <div v-for="option in props.options">
              <Checkbox v-model="form.options" :value="option.id"
                              :inputId="'option_' + option.id" class="hidden" />
              <label :for="'option_' + option.id"
                  :class="form.options.includes(option.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                  class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                  option.name }}</label>
            </div>
        </div>
        <div v-if="form.errors.options" class="text-red-500 text-sm mt-1">
          {{ form.errors.options }}
        </div>
      </div>

      <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Geef nog eventueele toelichting </h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Voor als je nog iets over de auto wilt aangeven waar je
            hierboven geen optie voor kon vinden.</p>
        </div>
        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
          <div class="col-span-full">
            <label for="explanation" class="block text-sm font-medium leading-6 text-gray-900">Toelichting</label>
            <div class="mt-2">
              <textarea id="explanation" name="explanation" rows="7" v-model="form.explanation"
                class="textarea-style" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-6 flex items-center justify-end gap-x-6">
      <Link href="/portal/zoekopdrachten" type="button" class="text-sm font-semibold leading-6 text-gray-900">Annuleren</Link>
      <button type="submit"
        class="rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brightorange">Opslaan</button>
    </div>
  </form>
</template>
